import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-forest",
  "use": "icon-forest-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-forest\"><path d=\"M682.666667 512L384 85.333333 85.333333 512h79.36L0 768h298.666667v170.666667h170.666666v-170.666667h298.666667l-164.693333-256z\" p-id=\"8327\" /><path d=\"M859.306667 512H938.666667L640 85.333333l-101.973333 145.493334L764.586667 554.666667h-83.2l137.386666 213.333333H1024zM554.666667 810.666667h170.666666v128h-170.666666z\" p-id=\"8328\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol